export const STEP_APPOINTMENT = 'appointment';
export const STEP_FARES = 'fares';
export const STEP_FLIGHTS = 'flights';
export const STEP_ROOMS = 'rooms';
export const STEP_ACCOMMODATION = 'accommodation';
export const STEP_SERVICES = 'services';
export const STEP_CAR_RENTAL = 'carRental';
export const STEP_PERSONAL_DATA = 'personalData';
export const STEP_OVERVIEW = 'overview';
export const STEP_PAYMENT = 'payment';

export const BOOKING_STEPS = {
  appointment: STEP_APPOINTMENT,
  fares: STEP_FARES,
  flights: STEP_FLIGHTS,
  rooms: STEP_ROOMS,
  accommodation: STEP_ACCOMMODATION,
  services: STEP_SERVICES,
  carRental: STEP_CAR_RENTAL,
  personalData: STEP_PERSONAL_DATA,
  overview: STEP_OVERVIEW,
  payment: STEP_PAYMENT,
}
